var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.5 -3.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5,3.5a15.037,15.037,0,0,0-15,15.039c.824,19.951,29.179,19.945,30,0A15.037,15.037,0,0,0,18.5,3.5Zm0,28.495A13.454,13.454,0,0,1,5.079,18.539C5.816.688,31.186.693,31.921,18.539A13.454,13.454,0,0,1,18.5,31.995Z",
    transform: "translate(0 0)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.246,22.651A4.089,4.089,0,0,0,26.379,15.5a4.089,4.089,0,0,0-2.867,7.151c-4.521,1.595-5.627,9.621.314,9.932h5.106a4.234,4.234,0,0,0,3.079-1.368,3.853,3.853,0,0,0,.983-3.107A5.958,5.958,0,0,0,29.246,22.651Zm-2.867-5.6a2.553,2.553,0,1,1,0,5.1A2.553,2.553,0,1,1,26.38,17.053ZM31.369,28.7a2.388,2.388,0,0,1-2.437,2.33H23.827A2.388,2.388,0,0,1,21.39,28.7v-.591C21.624,21.845,31.914,22.366,31.369,28.7Z",
    transform: "translate(-7.88 -5.502)",
    fill: "#006"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfile);
export default __webpack_public_path__ + "static/media/icon-profile.6ad02ad5c3b3abca1315e88e2b4f353d.svg";
export { ForwardRef as ReactComponent };